/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";

const insights_api_url = process.env.REACT_APP_INSIGHTS_API + "/url";

interface IProps {
  number: number;
}
const Report = ({ number }: IProps) => {
  const [url, setUrl] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const axios = require("axios").default;
  const isAuth = localStorage.getItem("accessToken");
  useEffect(() => {
    setLoading(true);
    if (number) {
      axios
        .get(insights_api_url, {
          headers: {
            accept: "text/plain",
            Authorization: `Bearer ${isAuth}`,
          },
          params: {
            reportId: number,
          },
        })
        .then((response: any) => {
          setLoading(false);
          if (response.data) {
            setUrl(response.data);
          }
        })
        .catch((error: Record<string, number>) => {
          setLoading(false);
          console.error("ERROR:", error.response);
        });
    }
  }, []);
  return (
    <div className="h-full w-full flex flex-row justify-center items-center text-3xl font-foundersGrotesk">
      {loading ? (
        <div className="flex flex-row items-center justify-center">
          <p className="text-2xl">Fetching Report</p>
          <FaSpinner className="font-poppins ml-2 animate-spin text-agBarley500" />
        </div>
      ) : (
        <iframe
          src={url}
          title={`report${number}`}
          frameBorder="0"
          width="100%"
          height="100%"
        />
      )}
    </div>
  );
};

export default Report;
